import React from 'react'
import dayjs from 'dayjs'

import { T } from 'lib/tolgee'
import { numberUtils, formatMetricValues } from 'utils'

const TOLGEE_PREFIX = 'ReasoningVideoText'

export default function ReasoningVideoText({ reasoning, publishedAt }) {
  const type = reasoning?.type
  const data = type ? JSON.parse(reasoning?.json) : {}
  const timeElapsed = dayjs(publishedAt).from(dayjs())

  if (type === 'post_engagement_above_average') {
    return (
      <span>
        <T
          keyName={`${TOLGEE_PREFIX}-postEngagementAboveAverage`}
          parameters={{
            timeElapsed,
            value: formatMetricValues(data?.ratio * 100),
            strong: <strong />,
          }}
        >
          {"{timeElapsed}, this video engaged <strong>{value}%</strong> of its creator's average"}
        </T>
      </span>
    )
  }

  if (type === 'post_most_liked') {
    return (
      <span>
        <T
          keyName={`${TOLGEE_PREFIX}-postMostLiked`}
          parameters={{
            timeElapsed,
            value: numberUtils.format(data?.likes),
            strong: <strong />,
          }}
        >
          {
            '{timeElapsed}, this is the most engaged video this week from this topic with <strong>{value} likes</strong>'
          }
        </T>
      </span>
    )
  }

  if (type === 'top_niche_post_most_liked_this_week') {
    return (
      <span>
        <T
          keyName={`${TOLGEE_PREFIX}-topNichePostMostLikedThisWeek`}
          parameters={{
            timeElapsed,
            niche: data?.niche_title,
            value: numberUtils.format(data?.likes),
            strong: <strong />,
          }}
        >
          {
            '{timeElapsed}, this is the most engaged video from <strong>{niche}</strong> this week with <strong>{value} likes</strong>'
          }
        </T>
      </span>
    )
  }

  if (type === 'top_niche_post_most_liked_overall') {
    return (
      <span>
        <T
          keyName={`${TOLGEE_PREFIX}-topNichePostMostLikedOverall`}
          parameters={{
            timeElapsed,
            niche: data?.niche_title,
            value: numberUtils.format(data?.likes),
            strong: <strong />,
          }}
        >
          {
            '{timeElapsed}, this is the most engaged video from <strong>{niche}</strong> with <strong>{value} likes</strong>'
          }
        </T>
      </span>
    )
  }

  return null
}
